import React, { useRef } from 'react';

import { Carousel } from '@components/carousel/Carousel';
import { ListingCarouselHeader } from '@components/programme/listingCarousel/ListingCarouselHeader';
import { ListingThumbnail } from '@components/programme/ListingThumbnail';

import { useCarousel } from '@hooks/useCarousel';
import { SupabaseEventRecord } from '@interfaces';

import styles from './listing-carousel.module.scss';

interface ListingCarouselProps {
	title: string;
	events: SupabaseEventRecord[];
	style?: React.CSSProperties;
}

export const ListingCarousel = ({
	title,
	events,
	style,
}: ListingCarouselProps) => {
	const scrollerRef = useRef<HTMLDivElement>(null);
	const listRef = useRef<HTMLUListElement>(null);

	const carouselRefs = { scrollerRef, listRef };

	const carouselButtonProps = useCarousel(carouselRefs);

	if (!events.length) return null;

	return (
		<article className={styles['listing-carousel']} style={style}>
			<ListingCarouselHeader
				className={styles.header}
				title={title}
				{...carouselButtonProps}
			/>
			<Carousel
				className={styles.carousel}
				hasControls={false}
				refs={carouselRefs}
				{...carouselButtonProps}
			>
				{events.map((event) => (
					<ListingThumbnail
						className={styles.event}
						event={event}
						headingTag="h3"
						isBadgeListHidden
						key={event.id}
						sizes="(min-width: 56.25em) 28.3333vw, (min-width: 37.5em) 43.75vw, 90vw"
					/>
				))}
			</Carousel>
		</article>
	);
};
